export default "__VITE_ASSET__ae38237c__"